module.exports = __webpack_public_path__ + "img/rocket-outline.73847c77.svg";